<template>
    <div class="background">
        <a-icon
            class="failed-icon"
            theme="filled"
            type="close-circle" />
        <div class="title">
            设备激活失败
        </div>
        <div class="device-number">
            编号: {{ boxNumber }}
        </div>
        <div class="error-area">
            {{ error }}
        </div>
        <div class="bottom-button-area">
            <div
                v-on:click="ok"
                class="button">
                完成
            </div>
        </div>
    </div>
</template>

<script>
 export default {
     name: 'BindFailed',
     data() {
         return {
             error: "",
             boxNumber: "未知",
         }
     },
     props: {
     },
     components: {
     },
     mounted() {
         if (sessionStorage.getItem("bindFailedStatus")) {
             if (sessionStorage.getItem("bindFailedStatus") == 1) {
                 this.error = "还没有开过门，所以无法检测"
             } else if (sessionStorage.getItem("bindFailedStatus") == 2) {
                 this.error = "已开过门，视频正在上传中"
             } else if (sessionStorage.getItem("bindFailedStatus") == 4) {
                 this.error = "服务器内部错误"
             } else if (sessionStorage.getItem("bindFailedStatus") == 8) {
                 this.error = "主控已经激活过，无需激活"
             }

             sessionStorage.setItem("bindFailedStatus", "")
         }

         if (sessionStorage.getItem("bindFailedUploadStatus")) {
             if (sessionStorage.getItem("bindFailedUploadStatus") == "reboot") {
                 this.error = "视频上传过程中主控重启了，请检查主控"
             } else if (sessionStorage.getItem("bindFailedUploadStatus") == "delay") {
                 this.error = "视频上传过程中中断过，不是一次性上传完成"
             } else {
                 this.error = "视频上传过程中发生未知错误: " + sessionStorage.getItem("bindFailedUploadStatus")
             }

             sessionStorage.setItem("bindFailedUploadStatus", "")
         }

         if (sessionStorage.getItem("bindFailedNumber")) {
             this.boxNumber = sessionStorage.getItem("bindFailedNumber")

             sessionStorage.setItem("bindFailedNumber", "")
         }
     },
     methods: {
         ok() {
             this.$router.replace("/home")
         }
     }
 }
</script>

<style scoped>
 .background {
     width: 100%;
     height: 100%;
     position: relative;
 }

 .title {
     font-size: 30px;
     padding-top: 20px;
 }

 .device-number {
     font-size: 20px;
     font-weight: bold;
     margin-top: 10px;
     margin-bottom: 10px;
 }

 .bottom-button-area {
     width: 100%;
     position: absolute;
     bottom: 30px;
     display: flex;
     flex-direction: row;
     justify-content: center;
 }

 .button {
     width: 50%;
     background-color: #20273E;
     height: 40px;
     border-radius: 50px;
     color: white;
     font-size: 15px;
     border: none;
     display: flex;
     flex-direction: column;
     align-items: center;
     justify-content: center;
 }

 .error-block {
     background-color: #FFF;
     box-shadow: #B4B4B4 0 0 5px 0;
     margin: 20px;
     padding: 10px;
     border-radius: 5px;
 }

 .error-title {
     font-size: 18px;
     text-align: start;
 }

 .error-fix {
     font-size: 14px;
     text-align: start;
     color: #666;
     margin-top: 10px;
 }

 .error-area {
     margin-top: 40px;
 }

 .failed-icon {
     margin-top: 20px;
     font-size: 60px;
     color: #E60011;
 }
</style>
